import type { Role } from "api/generated/model";

// all user roles except OrganizationLocalizationAdmin
const USER_ROLES: Role[] = [
    "OrganizationAdmin",
    "OrganizationUserAdmin",
    "OrganizationUserManager",
    "OrganizationRiskDirectoryManager",
    "OrganizationControlManager",
    "OrganizationReportManager",
    "OrganizationLogAdmin",
    "OrganizationTagAdmin",
    "OrganizationApiAdmin",
    "OrganizationTestingManager",
    "OrganizationControlEntityAdmin",
    "OrganizationMcpUser",
];

const USER_ROLE_COUNT = USER_ROLES.length; // don't count OrganizationLocalizationAdmin

interface UserRolesFeatureFlags {
    controlTestingEnabled: boolean;
    controlEntitiesEnabled: boolean;
    mcpEnabled: boolean;
}

function userRoles(featureFlags: UserRolesFeatureFlags): Role[] {
    let roles = USER_ROLES;
    if (!featureFlags.controlTestingEnabled) {
        roles = roles.filter((role) => role !== "OrganizationTestingManager");
    }
    if (!featureFlags.controlEntitiesEnabled) {
        roles = roles.filter(
            (role) => role !== "OrganizationControlEntityAdmin"
        );
    }
    if (!featureFlags.mcpEnabled) {
        roles = roles.filter((role) => role !== "OrganizationMcpUser");
    }
    return roles;
}

export { userRoles, USER_ROLE_COUNT };
